import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useEffect, useMemo } from 'react';

import { bimcCalculationGql } from '../calculationQueries';

const requestId = 'bimcCalculation';

export const useBimcCalculation = (calculationId?: number) => {
    const variables = useMemo(() => ({ calculationId }), [calculationId]);

    const [bimcCalculationReset] = useResetStoreData({ requestId });

    const [bimcCalculationData, bimcCalculationStatus] = useRequest({
        requestId,
        query: bimcCalculationGql,
        variables,
        withEffect: !!calculationId,
    });

    useEffect(() => {
        bimcCalculationReset(undefined);
    }, [bimcCalculationReset]);

    const data = useMemo(() => bimcCalculationData?.bimcCalculation?.data, [bimcCalculationData]);

    return {
        status: bimcCalculationStatus,
        data,
    };
};
